module.exports = __webpack_public_path__ + "static/media/fruit-banana-2.eac68e2d.png";